export default "__VITE_ASSET__CEiPh6eW__"